import { render, staticRenderFns } from "./MiscQuoteItems.vue?vue&type=template&id=28c5fa49"
import script from "./MiscQuoteItems.vue?vue&type=script&lang=js"
export * from "./MiscQuoteItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28c5fa49')) {
      api.createRecord('28c5fa49', component.options)
    } else {
      api.reload('28c5fa49', component.options)
    }
    module.hot.accept("./MiscQuoteItems.vue?vue&type=template&id=28c5fa49", function () {
      api.rerender('28c5fa49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/miscquote/MiscQuoteItems.vue"
export default component.exports